module.exports = __webpack_public_path__ + "img/repeat-1.5e4b25d1.svg";